var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { right: "" } },
    [
      !_vm.small && !_vm.icon
        ? _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md4: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "my-1",
                          attrs: {
                            flat: "",
                            large: "",
                            color: "primary",
                            title: "upload labels",
                            disabled:
                              _vm.files.length >= _vm.maxFiles || _vm.disabled
                          },
                          on: {
                            click: function($event) {
                              return _vm.$refs.fileInput.click()
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mx-2",
                              attrs: { dark: "", large: "" }
                            },
                            [_vm._v("cloud_upload")]
                          ),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("uploadFileWithMax", {
                                  maxFiles: _vm.maxFiles
                                })
                              ) +
                              "\n          "
                          ),
                          _c("input", {
                            ref: "fileInput",
                            staticClass: "upload-file",
                            attrs: {
                              type: "file",
                              multiple: _vm.maxFiles > 1,
                              accept: _vm.acceptTypes.join(",")
                            },
                            on: {
                              click: _vm.clearSelectionCache,
                              change: _vm.fileSelected
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md8: "" } },
                    _vm._l(_vm.files, function(item, index) {
                      return _c(
                        "v-layout",
                        {
                          key: item.file.name + index,
                          attrs: { "align-center": "", "justify-end": "" }
                        },
                        [
                          _vm.isShowPreview
                            ? _c(
                                "v-flex",
                                {
                                  staticClass: "text-lg-right text-md-right",
                                  attrs: { xs12: "", sm8: "", md8: "" }
                                },
                                [
                                  item.metadata
                                    ? _c("FsFileChip", {
                                        key: "file" + index,
                                        staticClass: "ma-2",
                                        attrs: {
                                          file: item.metadata,
                                          width: "100%",
                                          "aspect-ratio": "1.7"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _c(
                                "v-flex",
                                {
                                  staticClass: "text-lg-right text-md-right",
                                  attrs: { xs12: "", sm8: "", md8: "" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        row: "",
                                        "justify-space-between": "",
                                        "px-2": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "mr-2 text-xs-right",
                                          staticStyle: { width: "order-sm6em" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(index + 1) +
                                              "/" +
                                              _vm._s(_vm.files.length)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(item.metadata.name))
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "stretchWidth",
                              attrs: { xs6: "", sm1: "", md1: "" }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.file.prettySize) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "ml-2",
                              attrs: { xs6: "", sm2: "", md1: "" }
                            },
                            [
                              item.task.snapshot.state === "running" &&
                              item.task.progress !== 100
                                ? _c("v-progress-circular", {
                                    staticClass: "ml-1",
                                    attrs: {
                                      size: 20,
                                      width: 3,
                                      rotate: 360,
                                      value: item.task.progress,
                                      color: "teal"
                                    }
                                  })
                                : item.task.snapshot.state === "error"
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        color: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.retryUploadFile(
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [_vm._v("refresh")]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [_vm._v("retry upload")])
                                    ]
                                  )
                                : _c(
                                    "v-icon",
                                    {
                                      staticClass: "ml-1",
                                      attrs: { color: "teal" }
                                    },
                                    [_vm._v("done")]
                                  )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.disabled
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", sm3: "", md1: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        dark: "",
                                        small: "",
                                        color: "red",
                                        icon: "",
                                        flat: "",
                                        disabled: _vm.isDisableCancelBtn
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.removeFileFromList(
                                            item,
                                            index
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", { attrs: { dark: "" } }, [
                                        _vm._v("cancel")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.small || _vm.icon
        ? _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                icon: _vm.icon,
                flat: _vm.icon,
                disabled: _vm.files.length >= _vm.maxFiles || _vm.disabled,
                loading: _vm.smallBtnUploadStatus === "uploading" || _vm.loading
              },
              on: {
                click: function($event) {
                  return _vm.$refs.fileInput.click()
                }
              }
            },
            [
              _vm._t("default", function() {
                return [_c("v-icon", [_vm._v(_vm._s(_vm.iconType))])]
              }),
              _vm._v(" "),
              _c("input", {
                ref: "fileInput",
                staticClass: "upload-file",
                attrs: {
                  type: "file",
                  multiple: _vm.maxFiles > 1,
                  accept: _vm.acceptTypes.join(",")
                },
                on: { click: _vm.clearSelectionCache, change: _vm.fileSelected }
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isUseCameraUpload
        ? _c("CameraUploadWidget", {
            attrs: {
              disabled: _vm.files.length >= _vm.maxFiles || _vm.disabled
            },
            on: { capturePhoto: _vm.capturePhoto }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b758b71", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b758b71","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadFileWidget.vue
// module id = null
// module chunks = 